export class Credentials {
  email: string;
  password: string;
  idToken: string;
  settings;
  readOnly;
  constructor(email, password, idToken) {
    this.email = email;
    this.password = password;
    this.idToken = idToken;
    this.settings = {};
    this.readOnly = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/credentials.ts